var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.audioTracks),function(track,i){return _c('audio-track',{key:i,attrs:{"track":track}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }